import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTestTableComponent from './CustomTestTableComponent';

const Custom: React.FC = () => {
  const { t } = useTranslation('tests');
  return (
    <Grid container spacing={2} sx={{ mt: 1, alignItems: 'stretch',  flexDirection: 'column' }}>
      <Grid size={8}>
        <Typography>{t('subPages.customIntro')}</Typography>
      </Grid>
      <Grid sx={{ mr: 4 }}>
        <CustomTestTableComponent />
      </Grid>
    </Grid>
  );
};

export default Custom;
